import type * as z from 'zod';

import { productAndServicesTemplateItemQuerySchema } from './products-and-services-template-item-query-schema';

export const productAndServicesTemplateItemMutationSchema = productAndServicesTemplateItemQuerySchema.omit({
  product: true,
});

export type ProductAndServicesTemplateItemMutationSchema = z.infer<typeof productAndServicesTemplateItemMutationSchema>;

export const productAndServicesTemplateItemCreateMutationSchema = productAndServicesTemplateItemMutationSchema.omit({
  id: true,
});

export type ProductAndServicesTemplateItemCreateMutationSchema = z.infer<
  typeof productAndServicesTemplateItemCreateMutationSchema
>;
